import React, {
  ChangeEvent,
  FormEvent,
  useEffect,
  useRef,
  useState,
  type FC,
} from "react";
import classes from "./ReviewModal.module.css";
import BackgroundMovieLayout from "./BackgroundMovieLayout";
import { convertMinutesToHoursAndMinutes } from "../Utils/helpers";
import { animate, motion, useAnimationControls } from "framer-motion";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { toggleReviewModal } from "../Slices/reviewModalSlice";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { usePostReviewMutation } from "../Slices/httpSlice";
import { toast } from "react-toastify";
import Spinner from "./Loaders/Spinner";
import {
  closeViewReviewModal,
  openViewReviewModal,
} from "../Slices/viewReviewModalSlice";
import MediaReviews from "./MediaDetails/MediaReviews";
import ScrollToTop from "./ScrollToTop";

type ViewReviewModalProps = {
  windowWidth: number;
  mediaDetails: any;
  mediaReviews: any;
  media_type: "movie" | "tv";
  //   handleMouseDown: (event: React.MouseEvent<HTMLButtonElement>) => void;
  //   handleMouseUp: (
  //     event: React.MouseEvent<HTMLButtonElement>,
  //     reviewId: number,
  //   ) => void;
  //   handleMouseMove: () => void;
};

const ViewReviewModal: FC<ViewReviewModalProps> = ({
  windowWidth,
  media_type,
  mediaDetails,
  mediaReviews,
  //   handleMouseDown,
  //   handleMouseMove,
  //   handleMouseUp,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const controls = useAnimationControls();

  const [selectedReview, setSelectedReview] = useState<any>(null);

  const variants = {
    hidden: {
      y: window.innerHeight,
      display: "none",
    },
    visible: {
      y: 0,
      display: "block",
    },
  };

  const { viewReviewModal, reviewId } = useAppSelector(
    (state) => state.viewReviewModalSlice
  );
  useEffect(() => {
    if (viewReviewModal) {
      controls.start("visible");

      if (modalRef.current) {
        modalRef.current.scrollTop = 0;
      }

      let filteredReviews = mediaReviews?.result.filter(
        (data: any) => data?.id === reviewId
      );
      setSelectedReview(filteredReviews[0]);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [viewReviewModal, reviewId]);

  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.userSlice);

  const closeReviewModal = () => {
    controls.start("hidden");
    dispatch(closeViewReviewModal());
  };

  console.log(reviewId, "rid");

  console.log(selectedReview, "sr");

  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setStartPosition({ x: event.clientX, y: event.clientY });
    setIsDragging(false);
  };

  const handleMouseUp = (
    event: React.MouseEvent<HTMLButtonElement>,
    reviewId: number
  ) => {
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      closeReviewModal();
      if (modalRef.current) {
        modalRef.current.scrollTop = 0;
      }
      setTimeout(() => {
        dispatch(openViewReviewModal({ reviewId: reviewId }));
      }, 500);
    }
  };

  const handleMouseMove = () => {
    setIsDragging(true);
  };

  const openReviewModal = () => {
    closeReviewModal();
    setTimeout(() => {
      dispatch(toggleReviewModal());
    }, 500);
  };

  return (
    <>
      <motion.div
        ref={modalRef}
        className={classes.modal}
        variants={variants}
        initial="hidden"
        animate={controls}
        transition={{
          duration: 0.5,
          type: "spring",
          damping: 10,
          stiffness: 100,
        }}
      >
        <BackgroundMovieLayout
          windowWidth={windowWidth}
          backdropImage={
            !mediaDetails?.result
              ? "error"
              : mediaDetails?.result?.backdrop_path
          }
        >
          <div className={classes.review_navbar}>
            <button
              className={classes.close_btn}
              type="button"
              onClick={closeReviewModal}
            >
              <i className={`pi pi-times ${classes.close_icon}`} />
            </button>
          </div>
          <div className={classes.movie_details_grid}>
            <div className={classes.movie_details_brief}>
              {media_type === "movie" ? (
                <p className={classes.title}>
                  {mediaDetails?.result?.title ?? mediaDetails?.result?.name}{" "}
                  <span className={classes.span}>
                    (
                    {new Date(mediaDetails?.result?.release_date).getFullYear()}
                    )
                  </span>
                </p>
              ) : (
                <p className={classes.title}>
                  {mediaDetails?.result?.title ?? mediaDetails?.result?.name}{" "}
                  <span className={classes.span}>
                    (
                    {new Date(
                      mediaDetails?.result?.first_air_date
                    ).getFullYear()}
                    {mediaDetails?.result?.status === "Ended"
                      ? ` - ${new Date(
                          mediaDetails?.result?.last_air_date
                        ).getFullYear()}`
                      : ` - `}
                    )
                  </span>
                </p>
              )}

              <div className={classes.info_container}>
                {mediaDetails?.result?.status === "Released" ? (
                  <>
                    <div className={classes.duration}>
                      <i className={`pi pi-circle-fill ${classes.bullet}`} />

                      <p className={classes.clock_time}>
                        {convertMinutesToHoursAndMinutes(
                          mediaDetails?.result?.runtime
                        )}
                      </p>
                    </div>
                    <div className={classes.rating}>
                      <img
                        src="/assets/images/star.png"
                        className={classes.star}
                        alt="star"
                      />
                      <p className={classes.rating_number}>
                        {mediaDetails?.result?.vote_average}
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={classes.duration}>
                      <i className={`pi pi-circle-fill ${classes.bullet}`} />
                      <p className={classes.clock_time}>
                        {mediaDetails?.result?.status}
                      </p>
                    </div>
                    <div className={classes.rating}>
                      <img
                        src="/assets/images/star.png"
                        className={classes.star}
                        alt="star"
                      />
                      <p className={classes.rating_number}>
                        {mediaDetails?.result?.vote_average}
                      </p>
                    </div>
                  </>
                )}
              </div>
              <div className={classes.overview_section}>
                <p className={classes.overview}>
                  {mediaDetails?.result?.overview}
                </p>
              </div>
            </div>
          </div>

          {selectedReview && (
            <div className={classes.user_review_section}>
              <div className={`${classes.full_review_card}`}>
                <div className={classes.review_rating_container}>
                  <img
                    src="/assets/images/star.png"
                    alt="star"
                    className={classes.review_star}
                  />
                  <div className={classes.review_rating_sub_container}>
                    <p className={classes.review_rating}>
                      {selectedReview?.stars_rated}
                    </p>
                    <span className={classes.slash}>/</span>
                    <p className={classes.review_rating_out_of}>10</p>
                  </div>
                </div>

                <div className={classes.review_intro_container}>
                  <p className={classes.review_headline}>
                    {JSON.parse(selectedReview?.review_headline)}
                  </p>
                  <div className={classes.review_by}>
                    <p className={classes.username}>
                      {selectedReview?.username}
                    </p>
                    <p className={classes.review_date}>
                      {new Date(selectedReview?.date_time).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        }
                      )}
                    </p>
                  </div>
                </div>

                <div className={classes.review_container}>
                  <p
                    className={classes.full_review}
                    dangerouslySetInnerHTML={{
                      __html: JSON.parse(selectedReview?.review).replace(
                        /\n/g,
                        "<br />"
                      ),
                    }}
                  ></p>
                </div>
              </div>
            </div>
          )}

          <div className={classes.section_drag_cards}>
            <div className={classes.section_cards}>
              <div className={classes.category_title_container}>
                <div className={classes.title_container}>
                  <p className={classes.category_title}>More Reviews</p>
                  <p className={classes.images_length}>
                    {mediaReviews?.result.length - 1}
                  </p>
                  <i className={`pi pi-chevron-right ${classes.chevron}`} />
                </div>
                <button
                  className={classes.add_review_btn}
                  onClick={openReviewModal}
                >
                  <i className={`pi pi-plus ${classes.add_icon}`} />
                  Add a Review
                </button>
              </div>

              <motion.div
                className={classes.section_review_card}
                style={{
                  gridTemplateColumns: `repeat(${
                    mediaReviews?.result.length - 1
                  }, 320px)`,
                }}
                drag="x"
                dragConstraints={{
                  top: 0,
                  left: -(windowWidth <= 800
                    ? 10 +
                      mediaReviews?.result.length * 320 +
                      mediaReviews?.result.length * 20 +
                      mediaReviews?.result.length * 1 -
                      windowWidth
                    : window.innerWidth * 0.05 +
                      mediaReviews?.result.length * 320 +
                      mediaReviews?.result.length * 20 +
                      mediaReviews?.result.length * 1 -
                      windowWidth),
                  right: 0,
                  bottom: 0,
                }}
                transition={{
                  type: "spring",
                  damping: 100,
                  stiffness: 100,
                }}
              >
                {mediaReviews?.result?.map((data: any, idx: number) => {
                  if (data?.id !== reviewId) {
                    return (
                      <button
                        className={classes.review_card}
                        key={idx}
                        onMouseDown={(event) => handleMouseDown(event)}
                        onMouseUp={(event) => handleMouseUp(event, data?.id)}
                        onMouseMove={handleMouseMove}
                      >
                        <div className={classes.review_rating_container}>
                          <img
                            src="/assets/images/star.png"
                            alt="star"
                            className={classes.review_star}
                          />
                          <div className={classes.review_rating_sub_container}>
                            <p className={classes.review_rating}>
                              {data?.stars_rated}
                            </p>
                            <span className={classes.slash}>/</span>
                            <p className={classes.review_rating_out_of}>10</p>
                          </div>
                        </div>

                        <div className={classes.review_intro_container}>
                          <p className={classes.review_headline}>
                            {JSON.parse(data?.review_headline)}
                          </p>
                          <div className={classes.review_by}>
                            <p className={classes.username}>{data?.username}</p>
                            <p className={classes.review_date}>
                              {new Date(data?.date_time).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric",
                                }
                              )}
                            </p>
                          </div>
                        </div>

                        <div className={classes.review_container}>
                          <p
                            className={classes.review}
                            dangerouslySetInnerHTML={{
                              __html: JSON.parse(data?.review).replace(
                                /\n/g,
                                "<br />"
                              ),
                            }}
                          ></p>
                        </div>
                      </button>
                    );
                  }
                })}
              </motion.div>
            </div>
          </div>
        </BackgroundMovieLayout>
      </motion.div>
    </>
  );
};

export default ViewReviewModal;
